import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular';
 
@Component({
  selector: 'thermometer-bar',
  templateUrl: 'thermometer-bar.html'
})
export class ThermometerBarComponent {
 
  thermometherColor:string;

  @Input('progress') progress;
 
  constructor(public events: Events) {
    this.thermometherColor="#FFFFFF";
    events.subscribe('updateThermometerColor', (color) => {
      this.thermometherColor = color;
    });
  }
 
}


// WEBPACK FOOTER //
// ./src/components/thermometer-bar/thermometer-bar.ts